import { render, staticRenderFns } from "./SectionContactCTA.vue?vue&type=template&id=6fe42c34&"
import script from "./SectionContactCTA.vue?vue&type=script&lang=js&"
export * from "./SectionContactCTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports